import cleanDeep from 'clean-deep'
import firebase from 'firebase';
import produce from "immer";

export const clean = (payload: ICheckoutPage): any => {
    try {
        return cleanDeep(
            produce(payload, (draft) => {
                draft.codes.forEach((code, index, arr) => {
                    arr[index].activation = {
                        dateFrom: firebase.firestore.Timestamp.fromDate(arr[index].activation.dateFrom) as any,
                        dateTo: firebase.firestore.Timestamp.fromDate(arr[index].activation.dateTo) as any,
                    }
                });

                draft.timers.forEach((timer, index, arr) => {
                    arr[index].activation = {
                        dateFrom: firebase.firestore.Timestamp.fromDate(arr[index].activation.dateFrom) as any,
                        dateTo: firebase.firestore.Timestamp.fromDate(arr[index].activation.dateTo) as any,
                    }
                });

            }), {
            emptyArrays: false,
            emptyStrings: false,
            emptyObjects: false,
        });
    } catch (error) {
        return undefined;
    }
}

export const format = (payload: any): ICheckoutPage | undefined => {
    try {
        return produce(payload, (draft: any) => {
            draft.codes.forEach((code: any, index: any, arr: any) => {
                arr[index].activation = {
                    dateFrom: arr[index].activation.dateFrom.toDate() as Date,
                    dateTo: arr[index].activation.dateTo.toDate() as Date,
                }
            });
    
            draft.timers.forEach((timer: any, index: any, arr: any) => {
                arr[index].activation = {
                    dateFrom: arr[index].activation.dateFrom.toDate() as Date,
                    dateTo: arr[index].activation.dateTo.toDate() as Date,
                }
            });
        }) as any as ICheckoutPage;
    } catch (error) {
        return undefined;
    }
    
}